import React, { createContext, useContext, useRef, useCallback, useState } from 'react';

const CACHE_TTL_MS = 30 * 60 * 1000; // 30 minutes

const DataCacheContext = createContext();

export function DataCacheProvider({ children }) {
  const cache = useRef({});
  const timestamps = useRef({});
  const [lastUpdated, setLastUpdated] = useState(null);

  const get = useCallback((key) => {
    const ts = timestamps.current[key];
    if (ts && Date.now() - ts > CACHE_TTL_MS) {
      delete cache.current[key];
      delete timestamps.current[key];
      return null;
    }
    return cache.current[key] ?? null;
  }, []);

  const set = useCallback((key, data) => {
    if (data === undefined) {
      delete cache.current[key];
      delete timestamps.current[key];
    } else {
      cache.current[key] = data;
      timestamps.current[key] = Date.now();
    }
    setLastUpdated(new Date());
  }, []);

  const clearAll = useCallback(() => {
    cache.current = {};
    timestamps.current = {};
    setLastUpdated(new Date());
  }, []);

  return (
    <DataCacheContext.Provider value={{ get, set, clearAll, lastUpdated }}>
      {children}
    </DataCacheContext.Provider>
  );
}

export function useDataCache() {
  return useContext(DataCacheContext);
}
